import { NgIf } from '@angular/common';
import { Component, inject, InjectionToken, Type, ViewChild } from '@angular/core';

import { Select2SelectedItemDirective } from './selected-item.directive';

export const DEFAULT_SELECTED_ITEM_COMPONENT = new InjectionToken<Type<Select2ItemComponent>>(
  'default selected item',
);

@Component({
  selector: 'rt-select-selected-item[multi]',
  standalone: true,
  imports: [Select2SelectedItemDirective, NgIf],
  template: `
    <ng-container *rtSelectSelectedItem="let dir; let item = item">
      {{ item.label }}
    </ng-container>
  `,
  providers: [
    {
      provide: Select2SelectedItemDirective,
      useFactory: () => inject(Select2ItemComponent).directive,
    },
  ],
})
export class Select2ItemComponent {
  @ViewChild(Select2SelectedItemDirective, { static: true })
  public directive: Select2SelectedItemDirective<any>;
}
